module.exports = __webpack_public_path__ + "img/mystic-miners-2.f54d1ef3.png";